import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { tailwindVariants } from "@air/tailwind-variants";
import * as RadixSelect from "@radix-ui/react-select";
import { forwardRef } from "react";
import { SelectIcon } from "./SelectIcon";
import { SelectValue } from "./SelectValue";
export const selectTrigger = tailwindVariants({
    base: "flex shrink-0 items-center justify-between gap-2 rounded border border-grey-5 bg-grey-1 px-2 text-16 text-grey-12 outline-none focus:ring-2 focus:ring-blue-9 disabled:cursor-not-allowed disabled:border-grey-5 disabled:bg-grey-1 disabled:text-grey-7",
    variants: {
        size: {
            "extra-large": "h-12 md:text-16",
            large: "h-10 md:text-14",
            medium: "h-8 md:text-14",
            small: "h-6 md:text-12"
        }
    },
    defaultVariants: {
        size: "medium"
    }
});
export const SelectTrigger = /*#__PURE__*/ forwardRef((param, forwardedRef)=>{
    let { children, className, placeholder, size, ...restOfProps } = param;
    return /*#__PURE__*/ _jsx(RadixSelect.Trigger, {
        className: selectTrigger({
            size,
            class: className
        }),
        "data-testid": "SELECT_TRIGGER",
        ...restOfProps,
        ref: forwardedRef,
        children: !!children ? children : /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(SelectValue, {
                    "data-testid": "SELECT_VALUE",
                    placeholder: placeholder
                }),
                /*#__PURE__*/ _jsx(SelectIcon, {
                    "data-testid": "SELECT_ICON"
                })
            ]
        })
    });
});
SelectTrigger.displayName = "SelectTrigger";
